(function () {
  var QUEUE_KEY = 'ml_queue';
  var SEEN_KEY = 'ml_queue_seen';
  var NUMBER_PLACEHOLDER = '__N__';
  var MODAL_DELAY_MS = 15000;
  var KLAVIYO_FRIST_MS = 2000;

  function parseJson(value) {
    if (!value) return null;
    if (value === '1') return { email: '', number: '', legacy: true };
    try {
      var parsed = JSON.parse(value);
      if (parsed && typeof parsed === 'object') return parsed;
    } catch (e) {}
    return { email: '', number: String(value) };
  }

  function readQueue() {
    try {
      return parseJson(window.localStorage.getItem(QUEUE_KEY));
    } catch (e) {
      return null;
    }
  }

  function writeQueue(email, number) {
    var current = readQueue() || {};
    var nextNumber = number ? String(number) : current.number || '';
    var payload = {
      email: (email || current.email || '').trim().toLowerCase(),
      number: nextNumber,
      points: typeof current.points === 'number' ? current.points : 0,
      actions: current.actions && typeof current.actions === 'object' ? current.actions : {},
      startNumber: current.startNumber || nextNumber
    };
    try {
      window.localStorage.setItem(QUEUE_KEY, JSON.stringify(payload));
    } catch (e) {}
    return payload;
  }

  function saveQueue(next) {
    var current = readQueue() || {};
    var payload = {
      email: next.email != null ? next.email : current.email || '',
      number: next.number != null ? String(next.number) : current.number || '',
      points: typeof next.points === 'number' ? next.points : current.points || 0,
      actions: next.actions && typeof next.actions === 'object' ? next.actions : current.actions || {},
      startNumber: next.startNumber || current.startNumber || current.number || ''
    };
    try {
      window.localStorage.setItem(QUEUE_KEY, JSON.stringify(payload));
    } catch (e) {}
    return payload;
  }

  function hasQueueFlag() {
    var stored = readQueue();
    return !!(stored && (stored.number || stored.email || stored.legacy));
  }

  function markSeen() {
    try {
      window.localStorage.setItem(SEEN_KEY, '1');
    } catch (e) {}
  }

  function hasSeen() {
    try {
      return window.localStorage.getItem(SEEN_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function interpolate(template, number) {
    if (!template) return '';
    return template.split(NUMBER_PLACEHOLDER).join(number || '');
  }

  function resolveCompanyId(fallback) {
    if (fallback) return fallback;
    var scripts = document.querySelectorAll('script[src*="klaviyo"]');
    for (var i = 0; i < scripts.length; i++) {
      var src = scripts[i].getAttribute('src') || '';
      var fromQuery = src.match(/company_id=([A-Za-z0-9]+)/);
      if (fromQuery) return fromQuery[1];
      var fromPath = src.match(/onsite\/js\/([A-Za-z0-9]{6})\//);
      if (fromPath) return fromPath[1];
    }
    return '';
  }

  function pickWaitlistNumber(value, depth) {
    if (value == null || depth > 6) return '';
    if (typeof value === 'string' || typeof value === 'number') return '';
    if (value.waitlist_number != null && String(value.waitlist_number) !== '') {
      return String(value.waitlist_number);
    }
    var nested = ['attributes', 'properties', 'profile', 'data'];
    for (var i = 0; i < nested.length; i++) {
      if (value[nested[i]]) {
        var found = pickWaitlistNumber(value[nested[i]], depth + 1);
        if (found) return found;
      }
    }
    return '';
  }

  function identifyKlaviyo(email) {
    try {
      if (!window.klaviyo) return;
      if (typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ email: email });
      } else if (typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['identify', { email: email }]);
      }
    } catch (e) {}
  }

  function fireWaitlistJoin(email, number) {
    var detail = { email: email, waitlist_number: number || '' };
    try {
      document.dispatchEvent(new CustomEvent('WaitlistJoin', { detail: detail }));
    } catch (e) {}
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: 'WaitlistJoin', email: email, waitlist_number: number || '' });
      }
    } catch (e) {}
    try {
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track('WaitlistJoin', detail);
      } else if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['track', 'WaitlistJoin', detail]);
      }
    } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('WaitlistJoin', detail);
      }
    } catch (e) {}
  }

  function fetchWaitlistNumber(companyId, done) {
    if (!companyId) {
      done('');
      return;
    }
    var attempts = 0;
    var maxAttempts = 5;

    function tick() {
      attempts += 1;
      fetch('https://fast.a.klaviyo.com/onsite/personalization?company_id=' + encodeURIComponent(companyId), {
        credentials: 'include',
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) return null;
          return response.json();
        })
        .then(function (data) {
          var number = pickWaitlistNumber(data, 0);
          if (number) {
            done(number);
            return;
          }
          if (attempts < maxAttempts) {
            setTimeout(tick, 450);
          } else {
            done('');
          }
        })
        .catch(function () {
          if (attempts < maxAttempts) {
            setTimeout(tick, 450);
          } else {
            done('');
          }
        });
    }

    setTimeout(tick, 350);
  }

  /* Guestlist-Platz vom Server (Otton 22.10.2026: "soll alles verbunden
     werden"). Bis dahin trug das Popup nur in Klaviyo ein und bekam keinen
     Platz; die Nummer kam aus Klaviyo (alte Warteliste) oder gar nicht.
     Nur fuer die Guestlist-Liste, und nie laenger als 4 s warten. */
  function serverPlatz(root, email) {
    if ((root.dataset.listId || '') !== 'WTbX8B' || !window.fetch) return Promise.resolve(0);
    var ab = window.AbortController ? new AbortController() : null;
    var uhr = setTimeout(function () { if (ab) ab.abort(); }, 4000);
    return fetch('/apps/guestlist/join', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, quelle: root.dataset.source || 'popup' }),
      signal: ab ? ab.signal : undefined
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (d) {
        clearTimeout(uhr);
        return d && d.platz > 0 ? d.platz : 0;
      });
  }

  function subscribeToKlaviyo(root, email) {
    var companyId = resolveCompanyId(root.dataset.companyId || '');
    var listId = root.dataset.listId || '';
    var source = root.dataset.source || 'Marinelie La Queue';

    if (!companyId || !listId) {
      return Promise.reject(new Error('config'));
    }

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: {
                  email: {
                    marketing: { consent: 'SUBSCRIBED' }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: listId }
          }
        }
      }
    };

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Revision: '2025-07-15'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) {
        return response.text().then(function (body) {
          throw new Error(body || String(response.status));
        });
      }
      identifyKlaviyo(email);
      return response.text().then(function (body) {
        var parsed = null;
        if (body) {
          try {
            parsed = JSON.parse(body);
          } catch (e) {}
        }
        return pickWaitlistNumber(parsed, 0);
      });
    });
  }

  function showMessage(root, text) {
    var messageEl = root.querySelector('[data-ml-queue-message]');
    if (!messageEl) return;
    messageEl.hidden = false;
    messageEl.textContent = text;
  }

  function showSuccess(root, kind, number) {
    var fields = root.querySelector('.ml-queue-form__fields');
    var messageEl = root.querySelector('[data-ml-queue-message]');
    var successEl = root.querySelector('[data-ml-queue-success]');
    var textEl = root.querySelector('[data-ml-queue-success-text]');
    var numberEl = root.querySelector('[data-ml-queue-number]');
    var template =
      kind === 'returning'
        ? root.dataset.i18nReturning
        : number
          ? root.dataset.i18nSuccess
          : root.dataset.i18nSuccessPending;

    root.classList.add('is-success');
    if (fields) fields.hidden = true;
    if (messageEl) messageEl.hidden = true;
    if (successEl) {
      successEl.hidden = false;
      if (textEl) textEl.textContent = interpolate(template, number);
      if (numberEl) {
        if (number) {
          numberEl.hidden = false;
          numberEl.textContent = String(number);
        } else {
          numberEl.hidden = true;
        }
      }
      if (typeof successEl.focus === 'function') successEl.focus();
    }
  }

  function bindForm(root) {
    if (!root || root.dataset.bound === '1') return;
    root.dataset.bound = '1';

    var form = root.querySelector('[data-ml-queue-submit]');
    if (!form) return;

    var input = form.querySelector('input[type="email"]');
    var button = root.querySelector('[data-ml-queue-button]');

    var storedOnLoad = readQueue();
    if (
      storedOnLoad &&
      storedOnLoad.number &&
      /* Auch auf der Duftseite: wer schon einen Platz hat, sieht ihn statt
         des Felds (Otton 22.10.2026, Version fuer Bekannte). */
      (root.getAttribute('data-ml-queue-mode') === 'hero' || root.getAttribute('data-ml-queue-mode') === 'pdp') &&
      !(window.Shopify && Shopify.designMode)
    ) {
      showSuccess(root, 'returning', storedOnLoad.number);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = (input && input.value ? input.value : '').trim().toLowerCase();

      if (!email || (input && !input.checkValidity())) {
        showMessage(root, root.dataset.i18nInvalid || '');
        if (input) input.focus();
        return;
      }

      var stored = readQueue();
      if (stored && stored.email && stored.email === email && stored.number) {
        showSuccess(root, 'returning', stored.number);
        return;
      }

      if (button) {
        button.disabled = true;
        button.classList.add('loading');
      }

      subscribeToKlaviyo(root, email)
        .then(function (numberFromBody) {
          return serverPlatz(root, email).then(function (platz) {
            return { platz: platz, numberFromBody: numberFromBody };
          });
        })
        .then(function (erg) {
          var numberFromBody = erg.numberFromBody;
          if (erg.platz) {
            var n = erg.platz.toLocaleString('de-DE');
            writeQueue(email, n);
            showSuccess(root, 'join', n);
            fireWaitlistJoin(email, n);
            return;
          }
          if (numberFromBody) {
            writeQueue(email, numberFromBody);
            showSuccess(root, 'join', numberFromBody);
            fireWaitlistJoin(email, numberFromBody);
            return;
          }
          writeQueue(email, '');
          fetchWaitlistNumber(resolveCompanyId(root.dataset.companyId || ''), function (number) {
            writeQueue(email, number);
            showSuccess(root, 'join', number);
            fireWaitlistJoin(email, number);
          });
        })
        .catch(function (error) {
          var key = error && error.message === 'config' ? 'i18nConfig' : 'i18nError';
          showMessage(root, root.dataset[key] || '');
          if (button) {
            button.disabled = false;
            button.classList.remove('loading');
          }
        });
    });
  }

  function closeModal(root) {
    if (!root) return;
    root.hidden = true;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('ml-queue-modal-open');
    markSeen();
  }

  function openModal(root) {
    if (!root || root.hidden === false && root.classList.contains('is-open')) return;
    root.hidden = false;
    root.classList.add('is-open');
    document.documentElement.classList.add('ml-queue-modal-open');
    markSeen();
    var input = root.querySelector('input[type="email"]');
    if (input) input.focus();
  }

  function bindModal(root) {
    if (!root || root.dataset.modalBound === '1') return;
    root.dataset.modalBound = '1';

    root.querySelectorAll('[data-ml-queue-dismiss]').forEach(function (el) {
      el.addEventListener('click', function () {
        closeModal(root);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        closeModal(root);
      }
    });
  }

  // Öffnen auf Zuruf (z. B. 15-ml-Chip der PDP) — unabhängig von seen/flag,
  // das Formular zeigt Eingetragenen ihren Rückkehrer-Stand selbst.
  document.addEventListener('ml:queue:open', function () {
    var modal = document.querySelector('[data-ml-queue-modal]');
    if (!modal) return;
    bindModal(modal);
    openModal(modal);
  });

  /* Ist die Person schon bei uns? Drei Quellen, die erste, die ja sagt,
     gilt: das Kundenkonto mit Newsletter (Liquid schreibt es ans Popup),
     das Klaviyo-Cookie __kla_id (identifiziert traegt es eine
     $exchange_id oder die Adresse), sonst Klaviyos eigenes Urteil
     (klaviyo.isIdentified). Klaviyo laedt erst nach der Cookie-Zustimmung;
     fehlt es, entscheidet das Cookie, und fehlt auch das, kommt das
     Popup wie bisher. Lieber einmal zu oft gefragt als nie. */
  function klaviyoCookieKennt() {
    var treffer = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
    if (!treffer) return false;
    try {
      var daten = JSON.parse(window.atob(decodeURIComponent(treffer[1])));
      return !!(daten && (daten.$exchange_id || daten.$email || daten.$phone_number));
    } catch (e) {
      return false;
    }
  }

  function kenntUnsSchon(modal, fertig) {
    if (modal && modal.getAttribute('data-kunde-newsletter') === '1') {
      fertig(true);
      return;
    }
    if (klaviyoCookieKennt()) {
      fertig(true);
      return;
    }
    try {
      if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
        /* window.klaviyo ist zuerst nur ein Platzhalter aus dem Einbett-
           Schnipsel: er sammelt Aufrufe und loest sie erst auf, wenn
           klaviyo.js geladen ist. Blockt ein Werbeblocker das Skript,
           kommt die Antwort nie, und das Popup ging nie auf (am
           11.10.2026 in der Abnahme ohne Klaviyo nachgestellt). Darum
           eine Frist: ohne Antwort gilt man als unbekannt. Geladen
           antwortet Klaviyo sofort (gemessen: 0 ms nach networkidle). */
        var erledigt = false;
        var einmal = function (bekannt) {
          if (erledigt) return;
          erledigt = true;
          fertig(bekannt);
        };
        window.setTimeout(function () { einmal(false); }, KLAVIYO_FRIST_MS);
        Promise.resolve(window.klaviyo.isIdentified()).then(
          function (ja) { einmal(!!ja); },
          function () { einmal(false); }
        );
        return;
      }
    } catch (e) {}
    fertig(false);
  }

  function initModal() {
    if (window.Shopify && Shopify.designMode) return;
    if (hasQueueFlag() || hasSeen()) return;

    var modal = document.querySelector('[data-ml-queue-modal]');
    if (!modal) return;

    bindModal(modal);

    var opened = false;
    function tryOpen() {
      if (opened || hasQueueFlag() || hasSeen()) return;
      opened = true;
      /* Otton, 11.10.2026: "dieses popup soll nur kommen, wenn man noch
         nicht eingetragen ist in klaviyo." Die Marke im Speicher kennt nur
         Eintraege auf diesem Geraet. Wer ueber einen Mail-Link kommt, auf
         einem anderen Geraet eingetragen ist oder als Kundin mit
         Newsletter angemeldet ist, sah das Popup trotzdem. */
      kenntUnsSchon(modal, function (bekannt) {
        if (!bekannt) openModal(modal);
      });
    }

    window.setTimeout(tryOpen, MODAL_DELAY_MS);

    document.addEventListener('mouseout', function (event) {
      if (event.clientY > 0) return;
      if (event.relatedTarget || event.toElement) return;
      tryOpen();
    });
  }

  function initChapters() {
    var chapters = document.querySelectorAll('[data-ml-chapter]');
    if (!chapters.length) return;

    var nav = document.querySelector('[data-ml-chapter-nav]');
    var bar = document.querySelector('[data-ml-chapter-bar]');
    var barTitle = bar && bar.querySelector('[data-ml-chapter-bar-title]');
    var barPrice = bar && bar.querySelector('[data-ml-chapter-bar-price]');
    var barButton = bar && bar.querySelector('[data-ml-chapter-bar-button]');

    var barLimited = bar && bar.querySelector('[data-ml-chapter-bar-limited]');
    var syncFromNav = false;
    var activeChapter = null;

    function chapterForLink(link) {
      if (!link) return null;
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return null;
      return document.getElementById(href.slice(1));
    }

    if (nav) {
      nav.innerHTML = '';
      chapters.forEach(function (chapter) {
        var shortLabel =
          chapter.getAttribute('data-ml-chapter-nav') || chapter.getAttribute('data-product-title') || '';
        var fullLabel = chapter.getAttribute('data-ml-chapter-nav-full') || shortLabel;
        var link = document.createElement('a');
        var shortEl = document.createElement('span');
        var fullEl = document.createElement('span');
        link.className = 'ml-queue-jump__link';
        link.href = '#' + chapter.id;
        shortEl.className = 'ml-queue-jump__link-short';
        shortEl.textContent = shortLabel;
        fullEl.className = 'ml-queue-jump__link-full';
        fullEl.textContent = fullLabel;
        link.appendChild(shortEl);
        link.appendChild(fullEl);
        nav.appendChild(link);
      });

      if (nav.dataset.sliderBound !== '1') {
        nav.dataset.sliderBound = '1';
        nav.addEventListener('click', function (event) {
          var link = event.target.closest('a');
          if (!link || !nav.contains(link)) return;
          var chapter = chapterForLink(link);
          if (!chapter) return;
          event.preventDefault();
          syncFromNav = true;
          chapter.scrollIntoView({ behavior: 'smooth', block: 'start' });
          applyChapter(chapter);
          window.setTimeout(function () {
            syncFromNav = false;
          }, 640);
        });
      }
    }

    function applyChapter(chapter) {
      if (!chapter || !bar) return;
      var available = chapter.getAttribute('data-available') === 'true';
      var limited = chapter.getAttribute('data-product-limited') || '';
      if (barTitle) barTitle.textContent = chapter.getAttribute('data-product-title') || '';
      if (barPrice) barPrice.textContent = chapter.getAttribute('data-product-price') || '';
      if (barLimited) {
        barLimited.textContent = limited;
        barLimited.hidden = !limited;
      }
      if (barButton) {
        barButton.disabled = !available;
        barButton.setAttribute('data-variant-id', chapter.getAttribute('data-variant-id') || '');
        barButton.textContent = available
          ? bar.getAttribute('data-i18n-atc') || barButton.textContent
          : bar.getAttribute('data-i18n-sold') || barButton.textContent;
      }
      bar.hidden = false;
      bar.classList.add('is-visible');
      if (nav) {
        nav.querySelectorAll('a').forEach(function (link) {
          link.classList.toggle('is-active', link.getAttribute('href') === '#' + chapter.id);
        });
      }
      activeChapter = chapter;
    }

    if (bar) {
      bar.hidden = false;
      bar.classList.add('is-visible');
      document.documentElement.classList.add('ml-queue-has-bar');
    }

    if ('IntersectionObserver' in window) {
      var visible = [];
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var idx = visible.indexOf(entry.target);
            if (entry.isIntersecting) {
              if (idx === -1) visible.push(entry.target);
            } else if (idx > -1) {
              visible.splice(idx, 1);
            }
          });
          if (visible.length && !syncFromNav) applyChapter(visible[visible.length - 1]);
        },
        { root: null, threshold: 0.35, rootMargin: '-12% 0px -35% 0px' }
      );
      chapters.forEach(function (chapter) {
        observer.observe(chapter);
      });
    }

    applyChapter(chapters[0]);

    if (barButton && bar && bar.dataset.barBound !== '1') {
      bar.dataset.barBound = '1';
      barButton.addEventListener('click', function () {
        var variantId = barButton.getAttribute('data-variant-id');
        if (!variantId || barButton.disabled) return;
        barButton.disabled = true;
        var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        fetch(addUrl + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (state) {
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(state);
            }
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          })
          .catch(function () {})
          .then(function () {
            barButton.disabled = false;
          });
      });
    }
  }

  function digits(value) {
    var n = parseInt(String(value == null ? '' : value).replace(/[^\d]/g, ''), 10);
    return n > 0 ? n : 0;
  }

  function formatCount(value, locale) {
    var n = typeof value === 'number' ? value : digits(value);
    try {
      return n.toLocaleString(locale && locale.indexOf('de') === 0 ? 'de-DE' : locale || undefined);
    } catch (e) {
      return String(n);
    }
  }

  function fillTemplate(template, token, value) {
    if (!template) return '';
    return template.split(token).join(value == null ? '' : String(value));
  }

  function initBehindDoor() {
    var root = document.querySelector('[data-ml-behind]');
    if (!root || root.dataset.behindBound === '1') return;
    root.dataset.behindBound = '1';

    var locale = root.getAttribute('data-locale') || 'de';
    var stored = readQueue() || {};
    var rank = digits(stored.number) || digits(root.getAttribute('data-next-number'));
    var start = digits(stored.startNumber) || rank;
    var waiting = digits(root.getAttribute('data-queue-count'));
    var points = typeof stored.points === 'number' ? stored.points : 0;
    var actions = stored.actions && typeof stored.actions === 'object' ? stored.actions : {};
    var tVorraum = digits(root.getAttribute('data-threshold-vorraum')) || 500;
    var tArchiv = digits(root.getAttribute('data-threshold-archiv')) || 100;
    var tLabor = digits(root.getAttribute('data-threshold-labor')) || 1;
    var numberEl = root.querySelector('[data-ml-behind-number]');
    var waitingEl = root.querySelector('[data-ml-behind-waiting]');
    var waitingShortEl = root.querySelector('[data-ml-behind-waiting-short]');
    var pointsEl = root.querySelector('[data-ml-behind-points]');
    var fillEl = root.querySelector('[data-ml-behind-fill]');
    var nowLabel = root.querySelector('[data-ml-behind-label="jetzt"]');
    var nextEl = root.querySelector('[data-ml-behind-next]');
    var nextWrap = root.querySelector('[data-ml-behind-next-wrap]');
    var statusEl = root.querySelector('[data-ml-behind-status]');
    var formattedRank = formatCount(rank, locale);

    if (numberEl) numberEl.textContent = formattedRank;
    if (nowLabel) nowLabel.textContent = fillTemplate(root.dataset.i18nNow, '__N__', formattedRank);
    if (waitingEl) {
      waitingEl.textContent = fillTemplate(
        root.dataset.i18nWaiting,
        '__C__',
        formatCount(waiting || Math.max(rank - 1, 0), locale)
      );
    }
    if (waitingShortEl) {
      waitingShortEl.textContent = fillTemplate(
        root.dataset.i18nWaitingShort || root.dataset.i18nWaiting,
        '__C__',
        formatCount(waiting || Math.max(rank - 1, 0), locale)
      );
    }
    if (pointsEl) pointsEl.textContent = fillTemplate(root.dataset.i18nPoints, '__P__', formatCount(points, locale));

    var fill = 0;
    if (rank > tVorraum) fill = 40 * Math.max(0, Math.min(1, (start - rank) / Math.max(start - tVorraum, 1)));
    else if (rank > tArchiv) fill = 40 + 30 * Math.max(0, Math.min(1, (tVorraum - rank) / Math.max(tVorraum - tArchiv, 1)));
    else fill = 70 + 30 * Math.max(0, Math.min(1, (tArchiv - rank) / Math.max(tArchiv - tLabor, 1)));
    if (rank <= tLabor) fill = 100;
    if (fillEl) fillEl.style.width = fill + '%';

    if (nextEl) {
      var nextRoom = '';
      var nextAt = 0;
      if (rank > tVorraum) {
        nextRoom = root.dataset.i18nRoomVorraum;
        nextAt = tVorraum;
      } else if (rank > tArchiv) {
        nextRoom = root.dataset.i18nRoomArchiv;
        nextAt = tArchiv;
      } else if (rank > tLabor) {
        nextRoom = root.dataset.i18nRoomLabor;
        nextAt = tLabor;
      }
      if (nextRoom && nextAt) {
        nextEl.textContent = fillTemplate(
          fillTemplate(root.dataset.i18nNext, '__C__', formatCount(rank - nextAt, locale)),
          '__R__',
          nextRoom
        );
        if (nextWrap) nextWrap.hidden = false;
      } else {
        nextEl.textContent = '';
        if (nextWrap) nextWrap.hidden = true;
      }
    }

    root.querySelectorAll('[data-ml-behind-room]').forEach(function (roomEl) {
      var unlock = parseInt(roomEl.getAttribute('data-unlock') || '0', 10) || 0;
      var open = unlock === 0 || rank <= unlock;
      var statusNode = roomEl.querySelector('[data-ml-behind-room-status]');
      roomEl.classList.toggle('is-open', open);
      roomEl.classList.toggle('is-locked', !open);
      if (statusNode) {
        statusNode.textContent = open
          ? root.dataset.i18nOpen || statusNode.textContent
          : fillTemplate(root.dataset.i18nFrom, '__N__', formatCount(unlock, locale));
      }
      if (!open && roomEl.tagName === 'A') {
        roomEl.addEventListener('click', function (event) {
          event.preventDefault();
        });
      }
    });

    root.querySelectorAll('[data-ml-behind-action]').forEach(function (el) {
      var key = el.getAttribute('data-ml-behind-action');
      var award = parseInt(el.getAttribute('data-points') || '0', 10) || 0;
      if (actions[key]) el.classList.add('is-done');
      el.addEventListener('click', function (event) {
        if (actions[key]) return;
        actions[key] = true;
        points += award;
        saveQueue({ points: points, actions: actions, number: stored.number, email: stored.email, startNumber: stored.startNumber });
        el.classList.add('is-done');
        if (pointsEl) pointsEl.textContent = fillTemplate(root.dataset.i18nPoints, '__P__', formatCount(points, locale));

        if (key === 'invite' || key === 'share') {
          event.preventDefault();
          var shareUrl = root.getAttribute('data-share-url') || window.location.href;
          var title = root.dataset.i18nShareTitle || document.title;
          var copied = root.dataset.i18nCopied || '';
          if (navigator.share) {
            navigator.share({ title: title, url: shareUrl }).catch(function () {});
          } else if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(shareUrl).then(function () {
              if (statusEl) {
                statusEl.hidden = false;
                statusEl.textContent = copied;
              }
            }).catch(function () {});
          }
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-ml-queue-form]').forEach(bindForm);
    initModal();
    initChapters();
    initBehindDoor();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('[data-ml-queue-form]').forEach(bindForm);
    if (event.target.querySelector('[data-ml-chapter], [data-ml-chapter-nav], [data-ml-chapter-bar]')) {
      initChapters();
    }
    if (event.target.querySelector('[data-ml-behind]')) {
      initBehindDoor();
    }
  });
})();
